import { useAuth } from "../context/AuthProvider";
import Loader from "../components/shared/Loader/Loader";
import { UserService } from "../services/UserService";
import Login from "../components/Login/Login";

const ProtectedRoutesConfig = ({ element }: any) => {
  const auth = useAuth();
  if (auth?.isLoading) {
    return <Loader />;
  }

  return auth?.isLoggedIn === "true" || UserService.isLoggedIn === "true" ? (
    element
  ) : (
    <Login />
  );
};

export default ProtectedRoutesConfig;
